import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../../Components/formElements/InputField";
import logistics from "../../../../../services/logistics_appCommonService";
import toast from "react-hot-toast";

//Redux
import { useDispatch } from "react-redux";
import {
  validateName,
  validateRequired,
  validateTextArea,
} from "../../../../../common/Validations";
import {
  getBankList,
} from "../../../../../redux/feature/logistics_app/logisticsSlice";
import { TextAreaField } from "../../../../../Components/formElements/TextAreaField";
import FailureModal from "../../../../../Components/Modal/supplier_app/FailureModal";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  IFSC_CODE: "Enter valid IFSC code",
};

const BankModal = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);

  /* pop failure modal data*/
  const FailureFuelEntry = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getFailureBankEntry] = useState(FailureFuelEntry);

  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureBankEntry] = useState(false);

  const [formInputs, setFormInputs] = useState({
    bankKey: "",
    bankAccountName: "",
    bankCountryDescription: "",
    bankAddress: "",
    bankCity: "",
    bankCurrency: "",
    bankBranchName: "",
    bankRegion: "",
  });

  const [validation, setValidation] = useState({
    bankKey: "",
    bankAcNo: "",
    bankAccountName: "",
    bankCountryDescription: "",
    bankAddress: "",
    bankCity: "",
    bankCurrency: "",
    bankBranchName: "",
    bankRegion: "",
  });
  const handleInputChange = ({ target: { name, value } }) => {
    // Real-time validation
    let error = "";

    if (name === "bankBranchName" && !validateRequired(value)) {
      error = message.VALID_CUSTOMER_NAME;
    }

    if (name === "bankAccountName" && !validateName(value)) {
      error = message.FILL_REQUIRED_FIELD;
    }

    if (name === "bankCity" && !validateName(value)) {
      error = message.FILL_REQUIRED_FIELD;
    }

    if (name === "bankCountryDescription" && !validateName(value)) {
      error = message.FILL_REQUIRED_FIELD;
    }

    if (name === "bankKey" && !validateIFSCCode(value)) {
      error = message.IFSC_CODE;
    }

    if (name === "bankCurrency" && !validateName(value)) {
      error = message.FILL_REQUIRED_FIELD;
    }

    if (name === "bankRegion" && !validateName(value)) {
      error = message.FILL_REQUIRED_FIELD;
    }

    // Update form input values
    setFormInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));

    // Update validation errors
    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const validateIFSCCode = (ifscCode) => {
    // Ensure the value follows the IFSC format: 4 uppercase letters, 0, then 6 alphanumeric characters
    const isValid = /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifscCode);
    return isValid;
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {
    bankKey: "",
    bankAcNo: "",
    bankAccountName: "",
    bankCountryDescription: "",
    bankAddress: "",
    bankCity: "",
    bankCurrency: "",
    // beneficiaryName: "",
    bankBranchName: "",
  };

  //handle cancel modal
  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));

    props.onHide();
  };

  const handleSave = async () => {
    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== ""
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      return;
    }
    if (!validateRequired(formInputs.bankAccountName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankAccountName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateName(formInputs.bankAccountName)) {
      requiredFields.push(`${message.VALID_CUSTOMER_NAME}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankAccountName: message.VALID_CUSTOMER_NAME,
      }));
      return;
    }
    if (!validateIFSCCode(formInputs.bankKey)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankKey: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateIFSCCode(formInputs.bankKey)) {
      requiredFields.push(`${message.VALID_CUSTOMER_NAME}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankKey: message.VALID_CUSTOMER_NAME,
      }));
      return;
    }
    if (!validateRequired(formInputs.bankBranchName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankBranchName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.bankBranchName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankBranchName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.bankCity)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankCity: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateName(formInputs.bankCity)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankCity: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.bankCountryDescription)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankCountryDescription: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateName(formInputs.bankCountryDescription)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankCountryDescription: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.bankRegion)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankRegion: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateName(formInputs.bankRegion)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankRegion: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.bankAddress)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankAddress: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateTextArea(formInputs.bankAddress)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankCountryDescription: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.bankCurrency)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankCurrency: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateName(formInputs.bankCurrency)) {
      requiredFields.push(`${message.VALID_CUSTOMER_NAME}`);
      setErrorFields(requiredFields);
      setShowFailureBankEntry(true);
      setValidation((prev) => ({
        ...prev,
        bankCurrency: message.VALID_CUSTOMER_NAME,
      }));
      return;
    }

    setFormInputs((prev) => ({ ...prev, ...initialState }));

    let obj = {
      data: formInputs,
    };
    setDisabled(true);

    await logistics.addBankMaster(obj).then((item) => {
      console.log(">> item!", item);
      if (item?.status === 200) {
        handleSearchFuncApi();
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });

        props.onHide();

        dispatch(getBankList({}));
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  const hideFailureModal = () => {
    setShowFailureBankEntry(false);
  };

  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getBankList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
    };
    dispatch(getBankList(obj));
  };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Bank Information
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Removed the two fields */}

        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">BD</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle"> Bank</span>
                  <span className="subHeaderTitle">Bank details</span>
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Bank Name"
                            placeholder=""
                            name="bankAccountName"
                            id="bankAccountName"
                            value={formInputs?.bankAccountName || ""}
                            error={validation.bankAccountName || ""}
                            onChange={handleInputChange}
                            // disabled={true}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Bank IFSC Code"
                            placeholder=""
                            name="bankKey"
                            id="bankKey"
                            value={formInputs?.bankKey || ""}
                            error={validation.bankKey || ""}
                            onChange={handleInputChange}
                            // disabled={true}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Branch Name"
                            placeholder=""
                            name="bankBranchName"
                            id="bankBranchName"
                            value={formInputs?.bankBranchName || ""}
                            error={validation.bankBranchName || ""}
                            onChange={handleInputChange}
                            // disabled={true}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Bank Address"
                            placeholder=""
                            name="bankAddress"
                            id="bankAddress"
                            value={formInputs?.bankAddress || ""}
                            error={validation.bankAddress || ""}
                            onChange={handleInputChange}
                            // disabled={true}
                            // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Bank City"
                            placeholder=""
                            name="bankCity"
                            id="bankCity"
                            value={formInputs?.bankCity || ""}
                            error={validation.bankCity || ""}
                            onChange={handleInputChange}
                            // disabled={true}
                            // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Bank Country"
                            placeholder=""
                            name="bankCountryDescription"
                            id="bankCountryDescription"
                            value={formInputs?.bankCountryDescription || ""}
                            error={validation.bankCountryDescription || ""}
                            onChange={handleInputChange}
                            // disabled={true}
                            // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Bank Region"
                            placeholder=""
                            name="bankRegion"
                            id="bankRegion"
                            value={formInputs?.bankRegion || ""}
                            error={validation.bankRegion || ""}
                            onChange={handleInputChange}
                            // disabled={true}
                            // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Bank Currency"
                            placeholder=""
                            name="bankCurrency"
                            id="bankCurrency"
                            value={formInputs?.bankCurrency || ""}
                            error={validation.bankCurrency || ""}
                            onChange={handleInputChange}
                            // disabled={true}
                            // required={true}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    Cancel
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btnTable"
                    disabled={disabled}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </Col>
              </Row>
            }
          </div>
        </div>
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureFuelData={getFailureBankEntry}
          requiredfields={getErrorFields}
        />
      </Modal.Body>
    </Modal>
  );
});

export default BankModal;
